/*
  18 Reasons — smooth open/close for the event product page accordions.

  A native <details> snaps open: the browser shows and hides the content in a
  single frame and there is nothing for CSS to transition, because the content
  is not rendered at all while closed. The fix is to keep <details> as the real,
  accessible control and animate the element's height around the moment the
  `open` attribute flips.

  Progressive enhancement: if this script never runs, the accordions still open
  and close natively - just without the animation. Nothing here is required for
  the content to be reachable.

  Only used by sections/main-product-event.liquid.
*/
(function () {
  var DURATION = 260;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var SELECTOR = '.product__event-accordion';

  // Honour the OS "reduce motion" setting: leave the native behaviour alone.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function EventAccordion(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.content = details.querySelector('.accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!this.summary || !this.content) return;
    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  EventAccordion.prototype.onClick = function (event) {
    if (reduceMotion.matches) return; // let the browser do its thing

    event.preventDefault();
    this.details.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  };

  EventAccordion.prototype.shrink = function () {
    this.isClosing = true;
    this.animate(this.details.offsetHeight, this.summary.offsetHeight, false);
  };

  EventAccordion.prototype.open = function () {
    // Pin the current height first, otherwise setting `open` makes the element
    // jump to its full size before the animation has a chance to start.
    this.details.style.height = this.details.offsetHeight + 'px';
    this.details.open = true;
    window.requestAnimationFrame(this.expand.bind(this));
  };

  EventAccordion.prototype.expand = function () {
    this.isExpanding = true;
    var target = this.summary.offsetHeight + this.content.offsetHeight;
    this.animate(this.details.offsetHeight, target, true);
  };

  EventAccordion.prototype.animate = function (from, to, willBeOpen) {
    // Cancel any in-flight animation so rapid clicking cannot leave the
    // element stuck at an intermediate height.
    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [from + 'px', to + 'px'] },
      { duration: DURATION, easing: EASING }
    );

    this.animation.onfinish = this.onFinish.bind(this, willBeOpen);
    this.animation.oncancel = this.reset.bind(this);
  };

  EventAccordion.prototype.onFinish = function (willBeOpen) {
    this.details.open = willBeOpen;
    this.reset();
    // Drop the inline height so the panel can reflow if its content changes
    // later (images loading, a variant swap re-rendering the section).
    this.details.style.height = '';
    this.details.style.overflow = '';
  };

  EventAccordion.prototype.reset = function () {
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  };

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.eventAccordionReady) return;
      el.dataset.eventAccordionReady = '1';
      new EventAccordion(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The theme editor re-renders sections without a page load, and product-info
  // swaps its own markup on variant change - both produce fresh <details>
  // elements that need wiring up again.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
